<div
    class="w-full flex flex-col items-center justify-center rounded-2xl px-1 py-8 dark:bg-white dark:bg-opacity-5"
    [ngClass]="[bgClass, textClass]"
>
    <div class="text-5xl font-semibold leading-none tracking-tight sm:text-7xl">
        {{ value }}
    </div>
    <div class="mt-1 text-sm font-medium sm:text-lg">
        {{ label }}
    </div>
</div>
